import {Reducer} from 'redux'
import {FoldersActionTypes, FoldersState} from './types';
import FoldersService from "../../services/FoldersService";

// Type-safe initialState!
const initialState: FoldersState = {
	list: [],
	expandedNodes: []
}

// Thanks to Redux 4's much simpler typings, we can take away a lot of typings on the reducer side,
// everything will remain type-safe.
const reducer: Reducer<FoldersState> = (state = initialState, action) => {
	switch (action.type) {
		case FoldersActionTypes.FETCH_ALL_REQUEST: {
			FoldersService.getAll()
			return { ...state, loading: true }
		}
		case FoldersActionTypes.FETCH_ALL_COMPLETED: {
			return { ...state, loading: false, list: action.payload}
		}
		case FoldersActionTypes.FETCH_ONE_REQUEST: {
			FoldersService.getOne(action.payload)
			return { ...state, loading: true }
		}
		case FoldersActionTypes.FETCH_ONE_COMPLETED: {
			// updates list but I do not see usage of this at the moment
			let foundIndex = state.list.findIndex(element => element.id === action.payload.id)
			state.list.splice(foundIndex, 1, action.payload)
			let newList = [...state.list]
			return { ...state, loading: false, list: newList}
		}
		case FoldersActionTypes.SAVE_REQUEST: {
			FoldersService.save(action.payload)
			return { ...state, loading: true }
		}
		case FoldersActionTypes.SAVE_COMPLETED: {
			console.log(action.payload)
			return { ...state, loading: false}
		}
		case FoldersActionTypes.DELETE_REQUEST: {
			FoldersService.delete(action.payload)
			return { ...state, loading: true }
		}
		case FoldersActionTypes.DELETE_COMPLETED: {
			let foundIndex = state.list.findIndex(element => element.id === action.payload.id)
			state.list.splice(foundIndex, 1)
			let newList = [...state.list]
			return { ...state, loading: false, list: newList}
		}
		case FoldersActionTypes.DELETE_MULTIPLE_REQUEST: {
			FoldersService.deleteMultiple(action.payload)
			return { ...state, loading: true }
		}
		case FoldersActionTypes.DELETE_MULTIPLE_COMPLETED: {
			action.payload.forEach((item: any) => {
				let foundIndex = state.list.findIndex(element => element.id === item.id)
				state.list.splice(foundIndex, 1)
			});
			let newList = [...state.list]
			return { ...state, loading: false, list: newList}
		}
		case FoldersActionTypes.SAVE_EXPANDED_NODES: {
			return { ...state, expandedNodes: action.payload }
		}
		default: {
			return state
		}
	}
}

// Instead of using default export, we use named exports. That way we can group these exports
// inside the `index.js` folder.
export { reducer as FoldersReducer }
